interface CertificationsSvgProps {
  size?: number;
  mainColor?: string;
  lighterColor?: string;
}

export function CertificationsSvg({
  size = 26,
  mainColor,
  lighterColor,
}: CertificationsSvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill={lighterColor}
        d="M14.231 7.116c0 .636.517 1.152 1.153 1.153h7.366V22.5H11.13l-.577-3.082a5.98 5.98 0 0 0 1.934-4.021L12.5 15a6 6 0 0 0-5.691-5.992L6.5 9q-.381 0-.75.048V.5h8.481zm7.424-.385H15.77V.807z"
      ></path>
      <path
        fill={mainColor}
        d="M6.5 10.5a4.5 4.5 0 0 1 2.41 8.298l1.05 5.601-3.459-1.153-3.46 1.153 1.05-5.6a4.5 4.5 0 0 1 2.41-8.3"
      ></path>
    </svg>
  );
}
